/**
 * Tamanho da tela como estado do React.
 *
 * O painel se comporta de formas diferentes no celular e no computador — no
 * Atendimento, principalmente: no computador as duas colunas convivem, no
 * celular a conversa toma a tela inteira, como no WhatsApp. Fazer isso só com
 * CSS obrigaria a montar as duas árvores sempre; assim a tela do celular monta
 * uma coisa só.
 *
 * Usa o MESMO ponto de corte do CSS (900px). Dois números diferentes viram
 * aquele bug em que a tela troca de layout mas o componente não sabe.
 */
import { useEffect, useState } from 'react';

export const CORTE_CELULAR = 900;

export function useEhCelular(): boolean {
  const consulta = () =>
    typeof window !== 'undefined' && window.matchMedia(`(max-width: ${CORTE_CELULAR}px)`).matches;

  const [ehCelular, setEhCelular] = useState(consulta);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${CORTE_CELULAR}px)`);
    const aoMudar = () => setEhCelular(mq.matches);
    aoMudar();
    mq.addEventListener('change', aoMudar);
    return () => mq.removeEventListener('change', aoMudar);
  }, []);

  return ehCelular;
}
